import { Link } from "react-router-dom";

interface SectionTitleProps {
  eyebrow: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionTitle({
  eyebrow,
  title,
  desc,
  actionLabel,
  actionTo,
}: SectionTitleProps) {
  return (
    <div className="mb-7 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <div className="flex items-center gap-2">
          <span className="h-3 w-[3px] rounded-full bg-accent-500"></span>
          <span className="font-label text-[11px] uppercase tracking-[0.28em] text-accent-500">
            {eyebrow}
          </span>
        </div>
        <h2 className="mt-2 font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {desc && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-500">{desc}</p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="group inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-accent-400"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5"></i>
        </Link>
      )}
    </div>
  );
}